<template>
  <div class="py-1">
    <div class="w-full border-gray-200 dark:border-gray-800 border-b absolute left-0 right-0" />
  </div>
</template>
